import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    CmpsButtonModule,
    CmpsCheckboxModule,
    CmpsChipModule,
    CmpsDialogModule,
    CmpsFilterModule,
    CmpsIconModule,
    CmpsPortalModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsNoteModule } from '../../coaching-note/notes.module';
import { CmpsCoachingTagsModule } from '../../coaching-tags/coaching-tags.module';
import { CmpsCommonModule } from '../../common/common.module';
import { CmpsCommentModule } from '../../evaluation/comment';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';
import { epicObs } from '../../store';
import {
    CmpsCaEvaluationModule,
    CmpsCaScoreSectionModule,
} from '../coach-assist';
import { CmpsTranscriptTitleModule } from '../core/pipe/transcript-title';

import { FocusComponent } from './component/focus/focus.component';
import { TranslationIdMap as FocusTranslationIdMap } from './component/focus/focus.i18n';
import { LandingComponent } from './component/landing/landing.component';
import { TranslationIdMap as LandingTranslationIdMap } from './component/landing/landing.i18n';
import { NotesPageComponent } from './component/notes-page/notes-page.component';
import { TranslationIdMap as NotesPageTranslationIdMap } from './component/notes-page/notes-page.i18n';
import { SummaryComponent } from './component/summary/summary.component';
import { TranslationIdMap as SummaryTranslationIdMap } from './component/summary/summary.i18n';
import { TranscriptDialogComponent } from './transcript-dialog.component';
import { transcriptDialogEpics } from './transcript-dialog.epic';
import { TranslationIdMap as DialogTranslationIdMap } from './transcript-dialog.i18n';

@NgModule({
    declarations: [
        FocusComponent,
        LandingComponent,
        NotesPageComponent,
        SummaryComponent,
        TranscriptDialogComponent,
    ],
    exports: [TranscriptDialogComponent],
    imports: [
        CmpsButtonModule,
        CmpsCaEvaluationModule,
        CmpsCaScoreSectionModule,
        CmpsCheckboxModule,
        CmpsChipModule,
        CmpsCoachingTagsModule,
        CmpsCommentModule,
        CmpsCommonModule,
        CmpsDialogModule,
        CmpsFilterModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(DialogTranslationIdMap),
        CmpsLazyI18nModule.forChild(FocusTranslationIdMap),
        CmpsLazyI18nModule.forChild(LandingTranslationIdMap),
        CmpsLazyI18nModule.forChild(NotesPageTranslationIdMap),
        CmpsLazyI18nModule.forChild(SummaryTranslationIdMap),
        CmpsNoteModule,
        CmpsPortalModule,
        CmpsTooltipModule,
        CmpsTranscriptTitleModule,
        CommonModule,
        FormsModule,
        NgxSliderModule,
        ReactiveFormsModule,
    ],
})
export class CmpsTranscriptDialogModule {
    constructor() {
        transcriptDialogEpics.forEach((e) => epicObs.next(e));
    }
}
